export default {
  Agreement: 'Agreement',
  Close: 'Close',
  'Commercial Card Application': 'Application Completed',
  'To generate the commercial card application please press the button below.':
    'To generate the commercial card application please press the button below.',
  'Generate Commercial Card Application': 'Generate Commercial Card Application',
  'Sign with DocuSign': 'Sign with DocuSign',
  'Download contract': 'Download Contract',
  'Sign and submit': 'Sign and submit',
  'Authorised signatory': 'Authorised signatory',
  'Your agreement has been sent to the {{email}} address to be signed':
    'Your agreement has been sent to the {{email}} address to be signed',
  'You are unable to procced with submission as you are not the authorized signatory of the company as per our system records.':
    'You are unable to procced with submission as you are not the authorized signatory of the company as per our system records.',
  'Choose another person': 'Choose Another Person',
  'Who will sign the contract?': 'Who will sign the contract?',
  'Select authorised signatory': 'Select authorised signatory',
  'We will send the invitation link to log in to the Portal.':
    'We will send the invitation link to log in to the Portal.',
  'There is no contract data': 'There is no contract data',
  'I agree to the Terms and Conditions, acknowledge to have received and read the full Terms and Conditions along with this Application':
    'I agree to the Terms and Conditions, acknowledge to have received and read the full Terms and Conditions along with this Application, a copy of the Terms and Conditions (as updated from time to time by Network) is uploaded a ',
  'Terms and Conditions link': 'https://www.network.ae/en/contents/view/merchant-terms-and-conditions',
  'Processing your contract signing with UAE PASS. The signed contract will load once signing process is complete.':
    'Processing your contract signing with UAE PASS. The signed contract will load once signing process is complete.',
  'We are fetching information from the UAE PASS. Use your UAE PASS application to allow document sharing.':
    'We are fetching information from the UAE PASS. Use your UAE PASS application to allow document sharing.',
  "Failed to fetch information from DocuSign. Press on 'Close' button below to reload this page and try again.":
    "Failed to fetch information from DocuSign. Press on 'Close' button below to reload this page and try again.",
  'Processing your contract signing with DocuSign. The signed contract will load once signing process is complete.':
    'Processing your contract signing with DocuSign. The signed contract will load once signing process is complete.',
  "The contract has been declined in DocuSign. Press on 'Close' button below to reload this page and try again.":
    "The contract has been declined in DocuSign. Press on 'Close' button below to reload this page and try again.",
  'Sign and upload Contract below': 'Sign and upload Contract below',
  'Please upload your contract before continuing': 'Please upload your contract before continuing',
};
